'use strict';

var util = angular.module('gymsystem.util');

util.directive('buttonlist', ['$rootScope', '$modal', '$location', 'util', function($rootScope, $modal, $location, util) {
    return {
        restrict: 'E',
        templateUrl: 'components/widgets/buttonlist/buttonlist.html',
        scope: {
            settings: '='
        },
        link: function($scope, $element) {
            $scope.hasPermission = $rootScope.hasPermission;

            var getContainerWidth = function() {
                return $element.find('.buttonlist')[0].clientWidth;
            };

            var isWide = function() {
                if ($rootScope.isMobile()) { return false; }
                return getContainerWidth() > 300;
            };

            $scope.getContainerClass = function() {
                return isWide() ? 'buttonlist-container' : 'buttonlist-container-small';
            };

            $scope.getButtonClass = function() {
                return isWide() ? '' : 'buttonlist-container-small';
            };


            // -------- Button functions ---------
            $scope.addCustomer = $rootScope.addCustomer;
            $scope.addWorkout = $rootScope.addWorkout;
            $scope.addGroup = function() {
                util.showDataDialog({controller: 'UserGroupDataCtrl' });
            };
            $scope.openCashier = function() {
                $modal.open({
                    templateUrl: 'views/getcashiermodal.html',
                    controller: 'GetCashierCtrl',
                    resolve: {
                        options: function() {
                            return {
                                open: true,
                                site: $rootScope.selectedSite
                            };
                        }
                    }
                }).result.then(function(cashier) {
                    if (!cashier && !cashier.selfcheckout) { return; }
                    $location.path('/checkout');
                });
            };
        }
    };
}]);
